// extracted by mini-css-extract-plugin
export default {"container":"S01_container__TYaWB","title":"S01_title__Ux3TR","desc":"S01_desc__ro8Gt","product":"S01_product__I5Ezr"};